/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_Discard_TitleInputs */



/**
* | output |
* | --- |
* | "Discard this agent?" |
*
* @param {Agent_Wizard_Discard_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_discard_title = /** @type {((inputs?: Agent_Wizard_Discard_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Discard_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diesen Agenten verwerfen?")
	return /** @type {LocalizedString} */ ("Discard this agent?")
});